<template>
  <div class="info">
    <div v-for="(item,index) in list" :key="index">
      <p>{{ useValue(item) }}</p>
      <span>{{ useName(item) }}</span>
    </div>
  </div>
</template>
<script>
import { hasDot } from '@/util/common';
export default {
  name: "flowPoolInfo",
  props: {
    info: {
      type: Object,
      default:() => {}
    }
  },
  data () {
    return {
      list: [
        {
          label: '总卡数(张)',
          key:'totalCard'
        },
        {
          label: '流量池基础套餐',
          key: 'specification',
          type:true
        },
        {
          label: '总流量',
          key: 'totalFlow',
          type:true
        },
        {
          label: '总使用流量',
          key: 'allUsageFlow',
          type:true
        },
        {
          label: '超流量数',
          key:'overFlowNum'
        },
        {
          label: '激活卡数(张)',
          key:'activeCardNum'
        },
        {
          label: '叠加包总流量',
          key: 'packageFlow',
          type:true
        },
      ]
    }
  },
  methods: {
    // 内容
    useValue (item) {
      if (!this.info) return '-';
      if(item.type){
        return this.info[item.key] ? this.formatterGprs(this.info[item.key]) : '-';
      } else{
        return this.info[item.key] || '-';
      }
    },
    // 名称
    useName (item) {
      return item.type ? item.label : item.label;
    },
    //流量转换
		formatterGprs(gprs) {
			if (!gprs) return '0kb';
			const flow = Math.abs(Number(gprs));
			const burden = Number(gprs) > 0;
			if (flow > 1024 * 1024) {
				let num = flow / (1024 * 1024);
				return `${burden ? '' : '-'}${hasDot(num)}G`;
			} else if (flow > 1024) {
				let num = flow / 1024;
				return `${burden ? '' : '-'}${hasDot(num)}M`;
			} else {
				return `${burden ? '' : '-'}${flow}kb`;
			}
		},
  }
}
</script>
<style lang="scss" scoped>
.info{
  width: 60%;
  height: calc(100% - 40px);
  display: grid;
  grid-template-columns:repeat(3,33.3333%);
  grid-template-rows: repeat(3,100px);
  padding: 40px 0;
  box-sizing: border-box;
  >div{
    text-align: left;
    font-size: 14px;
    >p{
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
      color: #FFF;
    }
    >span{
      color: #999;
    }
  }
}
</style>